const routes = {
  INDEX: '/',
  LOGIN: '/login',
  SIGNUP: '/signup',
  SIGNUP_A: '/signup/a',
  SIGNUP_B: '/signup/b',
  SIGNUP_I: '/signup/i',
  SIGNUP_J: '/signup/j',
  LOGOUT: '/logout',
  DEEP_LINK: '/deep-link',
  DEEP_LINK_APPSTORE: '/deep-link-appstore',
  FORGOT_PASSWORD: '/forgot-password',
  NEW_PASSWORD: '/new-password',
  NEW_PASSWORD_TOKEN: '/new-password/:token',
  CONTACT_US: '/contact-us',
  TERMS_OF_SERVICE: '/terms-of-service',
  PRIVACY_POLICY: '/privacy-policy',
  ANTI_HUMAN_TRAFFICKING_POLICY: '/anti-human-trafficking-policy',
  CONTENT_POLICY: '/content-policy',
  DATA_MANAGEMENT: '/data-management',
  CCPA_INFO: '/ccpa-info',
  MEMBER: '/member/:memberHash/:action(photos)?', // optional parameter `action`
  MEMBER_PHOTO: '/member/:memberHash/photo/:photoHash',
  MEMBER_BARE: '/member',
  GO_VIP: '/go-vip/:fromWhere',
  GO_VIP_BARE: '/go-vip',
  GO_VIP_ONE_TIME_OFFER: '/go-vip/one-time-offer',
  GO_VIP__SEE_ALL__PHOTOS: '/go-vip/see-all-photos',
  GO_VIP__CHAT: '/go-vip/chat',
  GO_VIP__FLIRTS: '/go-vip/flirts',
  GO_VIP__SHOW_INIT_UPGRADE: '/go-vip/show_initial_upgrade',
  GO_VIP__SETTINGS: '/go-vip/settings',
  GO_VIP__LIKES_ME: '/go-vip/likes-me',
  GO_VIP__VIEWED_ME: '/go-vip/viewed-me',
  CHECKOUT: '/checkout',
  PAYMENT_PROCESSING: '/payment-processing',
  SUCCESS_UPGRADE: '/success-upgrade',
  CHATS: '/chats',
  CHATS__TABS: '/chats/:tab(list|sent)',
  CHATS__LIST: '/chats/list',
  CHATS__SENT: '/chats/sent',
  CHAT: '/chat/:memberHash',
  CHAT_BARE: '/chat',
  MATCHES: '/matches',
  LIKES: '/likes',
  LIKES__TABS: '/likes/:tab(my|mutual|me)',
  LIKES__MY: '/likes/my',
  LIKES__MUTUAL: '/likes/mutual',
  LIKES__ME: '/likes/me',
  QUICK_MATCH: '/quick-match',
  ITS_MATCH: '/its-match',
  VIEWED: '/viewed',
  VIEWED__TABS: '/viewed/:tab(my|me)',
  VIEWED__MY: '/viewed/my',
  VIEWED__ME: '/viewed/me',
  SEARCH: '/search',
  SEARCH__REFINE: '/search/refine',
  WHOSONLINE: '/whosonline',
  WHOSONLINE__TABS: '/whosonline/:tab(recent|week)',
  WHOSONLINE__RECENT: '/whosonline/recent',
  WHOSONLINE__WEEK: '/whosonline/week',
  FAVORITES: '/favorites',
  FAVORITES__TABS: '/favorites/:tab(my|me)',
  FAVORITES__MY: '/favorites/my',
  FAVORITES__ME: '/favorites/me',
  BROWSE: '/browse',
  PROFILE: '/profile',
  PROFILE__EDIT: '/profile/edit',
  MOVE__AND__SCALE: '/move-and-scale',
  SETTINGS: '/settings',
  SETTINGS__PREFERENCES: '/settings/preferences',
  SETTINGS__NOTIFICATIONS: '/settings/notifications',
  SETTINGS__PRIVACY_LEVEL: '/settings/privacy-level',
  SETTINGS__DEACTIVATE_ACCOUNT: '/settings/options/deactivate-account',
  SETTINGS__DELETE_ACCOUNT: '/settings/options/delete-account',
  SETTINGS__CCPA_INFO: '/settings/options/ccpa-info',
  SETTINGS__TERMS_OF_SERVICE: '/settings/terms-of-service',
  SETTINGS__PRIVACY_POLICY: '/settings/privacy-policy',
  SETTINGS__CONTACT_US: '/settings/contact-us',
  SETTINGS__VISIBILITY_PREFERENCES: '/settings/visibility-preferences',
  SETTINGS__DATA_MANAGEMENT: '/settings/options/data-management',
  SETTINGS__CHANGE_PASSWORD: '/settings/options/change-password',
  SETTINGS__CHANGE_LANGUAGE: '/settings/options/language',
  SETTINGS__OPTIONS: '/settings/options',
  SETTINGS__SUBSCRIPTION_STATUS: '/settings/subscription-status',
  SETTINGS__ANTI_HUMAN_TRAFFICKING: '/settings/anti-human-trafficking-policy',
  SETTINGS__CONTENT_POLICY: '/settings/content-policy',
  INVALID_PHOTO: '/invalid-photo',
  INVALID_USERNAME: '/invalid-username',
  INVALID_TAGLINE: '/invalid-tagline',
  COREG_WELCOME: '/coreg-welcome',
  EXPLICIT_OPT_IN: '/explicit-opt-in',
  ANOTHER_CLIENT_CONNECTED: '/another-client-connected',
  UNSUBSCRIBE: '/unsubscribe',
  WELCOME_BACK: '/welcome-back',
  ONBOARDING: '/onboarding',
  INITIAL_OFFER: '/one-time-offer',
  SPEACIAL_OFFER_2X: '/show-special-offer-2x',
  NEARBY_CONNECT: '/nearby-connect',
  REFUND_CREDIT_CARD: '/refund-credit-card',
  NEARBY_CONNECT_SETUP: '/nearby-connect-setup',
  EMAIL_CONFIRMATION: '/email-confirmation',
};

export default routes;
